import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { RECOIL_PERSIST_KEY } from "../sharedStrings";
import { User } from "src/types/User";

const { persistAtom } = recoilPersist({
  key: RECOIL_PERSIST_KEY,
});

export const userState = atom<User | null>({
  key: `user`,
  default: null,
  effects_UNSTABLE: [persistAtom],
});
